import { render, staticRenderFns } from "./TableColumnHeader.vue?vue&type=template&id=83425a28&"
import script from "./TableColumnHeader.vue?vue&type=script&lang=ts&"
export * from "./TableColumnHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports